<div class="emma-table">
    <emma-loading *ngIf="loading || loadingUserMeta || error" [error]="error"></emma-loading>
    <div class="row" (click)="onRowActionsMenu(false)">
        <div class="col-md-6 emma-table-actions">
            <emma-select
                *ngIf="showTypeItems"
                [items]="selectableColumns"
                placeholder="Mostrando todo"
                valueKey="prop"
                labelKey="name"
                [multiple]="false"
                [multiLabel]="getMultiLabel"
                [isFullWidth]="false"
                [color]="colorSelect"
            ></emma-select>
            <emma-select
                *ngIf="showSelectColumns"
                [items]="selectableColumns"
                [ngModel]="selectedColumns"
                (ngModelChange)="onChangeColumns($event)"
                valueKey="prop"
                labelKey="name"
                [multiple]="true"
                [multiLabel]="getMultiLabel"
                [isFullWidth]="false"
                [allowSelectAll]="selectableColumns.length > 5"
                [defaultFirstValues]="minVisibleColumns"
                [minlength]="minVisibleColumns"
                [searchable]="selectableColumns.length > 10"
                [color]="colorSelect"
            ></emma-select>
            <emma-select
                *ngIf="showGroupBy"
                [items]="groupableColumns"
                [ngModel]="groupRowsBy"
                (ngModelChange)="onChangeGroupBy($event)"
                placeholder="Sin agrupar"
                valueKey="prop"
                labelKey="name"
                [multiple]="false"
                [clearable]="true"
                [clearOnBackspace]="true"
                [isFullWidth]="false"
                [color]="colorSelect"
                i18n-placeholder
            ></emma-select>
            <button
                *ngIf="showExportButton"
                emmaButton
                [color]="colorBtns"
                [isWide]="false"
                [hasIcon]="true"
                [isLink]="true"
                (click)="onExport()"
            >
                <span>
                    <i class="la la-cloud-download" aria-hidden="true"></i>
                    <span>{{ exportButtonText }}</span>
                </span>
            </button>
            <button
                *ngIf="showDownloadButton"
                emmaButton
                [color]="colorBtns"
                [isWide]="false"
                [hasIcon]="true"
                [isLink]="true"
                (click)="onDownload()"
            >
                <span>
                    <i class="la la-cloud-download" aria-hidden="true"></i>
                    <span>{{ downloadButtonText }}</span>
                </span>
            </button>
            <ng-template
                [ngTemplateOutlet]="tableActionsLeftTemplate"
                [ngTemplateOutletContext]="{
                    countUnit: countUnit,
                    countUnits: countUnits,
                    selectedColumns: selectedColumns,
                    selectableColumns: selectableColumns,
                    rowsLength: rows.length,
                }"
            ></ng-template>
        </div>
        <div class="col-md-6 m--align-right-desktop">
            <div class="input-group input-group-table">
                <div
                    *ngIf="_filterBy.length && showSearch"
                    class="input-group input-group-fluid filter-table-group"
                >
                    <emma-input
                        inputClass="form-control m-input m-input--solid filter-table-input"
                        placeholder="Buscar..."
                        inputmode="search"
                        [minlength]="minInputFilterLength"
                        [ngModel]="inputFilter"
                        (ngModelChange)="onChangeFilter($event)"
                        ($enter)="applyInputFilter()"
                        [showHelpMessageAtError]="true"
                        helpMessageAtError="Mínimo {{ minInputFilterLength }} caracteres."
                        i18n-ngbPopover
                        i18n-placeholder
                    ></emma-input>
                    <button
                        *ngIf="inputFilterButton"
                        emmaButton
                        color="metal"
                        [isWide]="false"
                        [hasIcon]="inputFilterButtonIcon"
                        [ngbPopover]="popoverButtonSearch"
                        (click)="applyInputFilter()"
                    >
                        <i
                            *ngIf="inputFilterButtonIcon && !inputFilterButtonText"
                            [class]="'la la-' + inputFilterButtonIcon"
                            aria-hidden="true"
                        ></i>
                        <span>
                            <i
                                *ngIf="inputFilterButtonIcon && inputFilterButtonText"
                                [class]="'la la-' + inputFilterButtonIcon"
                                aria-hidden="true"
                            ></i>
                            <span *ngIf="inputFilterButtonText">{{ inputFilterButtonText }}</span>
                        </span>
                        <ng-template #popoverButtonSearch>
                            <span i18n>Puedes pulsar <em>intro</em> para buscar.</span>
                        </ng-template>
                    </button>
                </div>
                <div
                    [ngClass]="{
                        'm--btn-group-action': true,
                        'm--auto-left-margin': !_filterBy.length,
                        'has-table-actions':
                            showCreateButton || tableActions.length || tableActionsRightTemplate,
                    }"
                >
                    <button
                        *ngFor="let action of tableActions"
                        emmaButton
                        color="metal"
                        [isWide]="true"
                        [hasIcon]="true"
                        (click)="action.$click && onActionClick($event, action)"
                    >
                        <span>
                            <i
                                *ngIf="action.icon"
                                [class]="'la la-' + (action.icon || '')"
                                aria-hidden="true"
                            ></i>
                            <span>{{ action.title }}</span>
                        </span>
                    </button>

                    <button
                        *ngIf="showCreateButton"
                        emmaButton
                        color="brand"
                        [isWide]="true"
                        [hasIcon]="true"
                        (click)="onNew()"
                    >
                        <span>
                            <i class="la la-plus-circle" aria-hidden="true"></i>
                            <span>{{ createButtonText }}</span>
                        </span>
                    </button>
                    <ng-template
                        [ngTemplateOutlet]="tableActionsRightTemplate"
                        [ngTemplateOutletContext]="{
                            countUnit: countUnit,
                            countUnits: countUnits,
                            selectedColumns: selectedColumns,
                            selectableColumns: selectableColumns,
                            rowsLength: rows.length,
                        }"
                    ></ng-template>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="visibleRows.length">
        <div class="emma-table--table row" [ngClass]="{ filtered: inputFilter, sorted: sortProp }">
            <div class="col-md-12">
                <div class="emma-table--responsive">
                    <table #tableScrolling>
                        <caption *ngIf="caption">
                            {{
                                caption
                            }}
                        </caption>
                        <thead #thead class="emma-table--thead">
                            <ng-template #defaultHeader>
                                <tr>
                                    <td
                                        *ngIf="
                                            rowActionsCallback ||
                                            (rowActions && rowActions.length) ||
                                            (showSummary && showCalcSummary)
                                        "
                                        [ngClass]="{
                                            'column-type--actions':
                                                rowActionsCallback || (rowActions && rowActions.length),
                                            'column-type--calc': showSummary && showCalcSummary,
                                        }"
                                    ></td>
                                    <th
                                        *ngFor="let col of visibleColumns; trackBy: trackByColumnProp"
                                        [id]="col.prop"
                                        [class]="'column-type--' + (col.dataType ? col.dataType : 'default')"
                                        [ngClass]="{
                                            sortable: col.sortable !== false,
                                            'column--group': groupRowsBy === col.prop,
                                            'column-sort': sortProp === col.prop,
                                            'column-sort--asc': sortProp === col.prop && sortDirection > 0,
                                            'column-sort--desc': sortProp === col.prop && sortDirection < 0,
                                        }"
                                        (click)="col.sortable !== false && onChangeSort(col.prop)"
                                        [ngbPopover]="col.description || ''"
                                        container="body"
                                        [ngStyle]="{
                                            'min-width.rem': col.width,
                                            'white-space': col.noWrapHeader ? 'nowrap' : '',
                                        }"
                                    >
                                        {{ col.name }}
                                        <span *ngIf="col.description" class="column-description-icon">
                                            <i class="la la-info-circle"></i>
                                        </span>
                                        <emma-table-column-sort-icon
                                            class="column-sortable-icon"
                                            *ngIf="col.sortable !== false"
                                            [direction]="sortProp === col.prop ? sortDirection : 0"
                                            [type]="col.dataType"
                                        ></emma-table-column-sort-icon>
                                    </th>
                                </tr>
                                <tr
                                    *ngIf="showSummary && summaryPosition === 'top'"
                                    class="row--summary"
                                    emma-table-summary-row
                                    [hasActions]="rowActionsCallback || (rowActions && rowActions.length)"
                                    [showCalc]="showSummary && showCalcSummary"
                                    [calcSummary]="calcSummary"
                                    [summaryCache]="_summaryCache"
                                    [columns]="visibleColumns"
                                    [colorSummaryBtn]="colorSummaryBtn"
                                    ($calc)="onChangeCalcSummary($event)"
                                ></tr>
                            </ng-template>
                            <ng-template
                                [ngTemplateOutlet]="tableHeaderTemplate ? tableHeaderTemplate : defaultHeader"
                                [ngTemplateOutletContext]="{
                                    rows: rows,
                                    visibleRows: visibleRows,
                                    columns: columns,
                                    visibleColumns: visibleColumns,
                                    selectedColumns: selectedColumns,
                                }"
                            ></ng-template>
                        </thead>
                        <tfoot>
                            <ng-template #defaultFooter>
                                <tr
                                    *ngIf="showSummary && summaryPosition === 'bottom'"
                                    class="row--summary"
                                    emma-table-summary-row
                                    [hasActions]="rowActionsCallback || (rowActions && rowActions.length)"
                                    [showCalc]="showSummary && showCalcSummary"
                                    [calcSummary]="calcSummary"
                                    [summaryCache]="_summaryCache"
                                    [columns]="visibleColumns"
                                    [colorSummaryBtn]="colorSummaryBtn"
                                    ($calc)="onChangeCalcSummary($event)"
                                ></tr>
                            </ng-template>
                            <ng-template
                                [ngTemplateOutlet]="tableFooterTemplate ? tableFooterTemplate : defaultFooter"
                                [ngTemplateOutletContext]="{
                                    rows: rows,
                                    visibleRows: visibleRows,
                                    columns: columns,
                                    visibleColumns: visibleColumns,
                                    selectedColumns: selectedColumns,
                                }"
                            ></ng-template>
                        </tfoot>
                        <tbody>
                            <tr
                                *ngFor="
                                    let row of visibleRows;
                                    index as rowIndex;
                                    even as even;
                                    odd as odd;
                                    trackBy: trackRowsByProp ? trackByRowId : undefined
                                "
                                [ngClass]="{
                                    'row--even': even,
                                    'row--odd': odd,
                                    'row--group': row.__groupRow,
                                }"
                            >
                                <td
                                    *ngIf="
                                        rowActionsCallback ||
                                        (rowActions && rowActions.length) ||
                                        (showSummary && showCalcSummary)
                                    "
                                    [ngClass]="{
                                        'column-type--actions':
                                            rowActionsCallback || (rowActions && rowActions.length),
                                        'column-type--calc': showSummary && showCalcSummary,
                                    }"
                                >
                                    <emma-table-row-actions
                                        *ngIf="
                                            ((rowActionsCallback && rowActionsCallback(row).length) ||
                                                (rowActions && rowActions.length)) &&
                                            !row.__groupRow
                                        "
                                        [row]="row"
                                        [index]="rowIndex"
                                        [actions]="rowActionsCallback ? rowActionsCallback(row) : rowActions"
                                        [showMenu]="activeRowActionsMenu === rowIndex"
                                        (active)="onRowActionsMenu($event, rowIndex)"
                                    ></emma-table-row-actions>
                                </td>
                                <td
                                    *ngFor="let col of visibleColumns; trackBy: trackByColumnProp"
                                    [class]="'column-type--' + (col.dataType ? col.dataType : 'default')"
                                    emma-table-row-cell
                                    [value]="getProp(row, col.prop)"
                                    [isEditable]="getProp(row, canEditProp, false)"
                                    [column]="col"
                                    ($rowCellActionEvent)="onRowCellActionEvent(col, row, $event)"
                                ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="emma-table--footer row">
            <div class="col-md-6 emma-table--pagination">
                <emma-pagination
                    *ngIf="maxPage > 0"
                    [curPage]="curPage"
                    (curPageChange)="onChangePage($event)"
                    [maxPage]="maxPage"
                    [maxPageLinks]="10"
                    [hasMorePages]="hasMorePages"
                ></emma-pagination>
            </div>
            <div class="col-md-6 emma-table--rpp-count">
                <div class="emma-table--rpp">
                    <emma-select
                        *ngIf="limits.length > 1"
                        [items]="limits"
                        [ngModel]="limit"
                        (ngModelChange)="onChangeLimit($event)"
                        dropdownPosition="top"
                        [color]="colorSelect"
                    ></emma-select>
                </div>
                <div class="emma-table--row-count">
                    <strong>{{ availableRows.length | formatNumber }}</strong>
                    &nbsp;
                    <strong>{{ availableRows.length === 1 ? countUnit : countUnits }}</strong>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="emma-table--no-result row" *ngIf="!visibleRows.length">
        <ng-template #defaultNoResults>
            <div class="col-md-12">
                <div *ngIf="!loading && !loadingUserMeta" class="emma-table--no-result__text">
                    <i class="las la-cloud-sun" aria-hidden="true"></i>
                    <span i18n>No hay {{ countUnits }} para mostrar esta tabla.</span>
                </div>
                <div *ngIf="loading || loadingUserMeta" class="emma-table--no-result__text">
                    <i class="la la-spinner la-spin" aria-hidden="true"></i>
                    <span i18n>Cargando {{ countUnits }}...</span>
                </div>
            </div>
        </ng-template>
        <ng-template
            [ngTemplateOutlet]="tableNoResultsTemplate ? tableNoResultsTemplate : defaultNoResults"
            [ngTemplateOutletContext]="{ countUnit: countUnit, countUnits: countUnits }"
        >
            >
        </ng-template>
    </div>
</div>
